

export function calculateBackgroundColor(color: string) {
  const [rInt, gInt, bInt] = hexToRgb(color);
  return rgbToHex(
      Math.floor(255 - (255 - rInt) / 4),
      Math.floor(255 - (255 - gInt) / 4),
      Math.floor(255 - (255 - bInt) / 4),
  )
}

export function calculateAccentColor(color: string) {
  const [rInt, gInt, bInt] = hexToRgb(color);
  return rgbToHex(
      Math.floor(rInt / 2),
      Math.floor(gInt / 2),
      Math.floor(bInt / 2),
  )
}

export function calculateColorLight(color: string) {
  const [rInt, gInt, bInt] = hexToRgb(color);
  return (rInt + gInt + bInt) / 3;
}

function hexToRgb(hexColor: string): [number, number, number] {
  // Remove the # if present
  const hexColorWithoutHash = hexColor.replace("#", "");

  // Convert the hex string to RGB values
  return [
    parseInt(hexColorWithoutHash.substring(0, 2), 16),
    parseInt(hexColorWithoutHash.substring(2, 4), 16),
    parseInt(hexColorWithoutHash.substring(4, 6), 16),
  ];
}

function rgbToHex(rInt: number, gInt: number, bInt: number): string {
  function twoDigitHex(xInt: number): string {
    const xHex = xInt.toString(16);
    if (xHex.length === 1) {
      return `0${xHex}`;
    }
    return xHex;
  }
  return `#${twoDigitHex(rInt)}${twoDigitHex(gInt)}${twoDigitHex(bInt)}`;
}
